import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 11h44v46H10V11z",
      stroke: "#1e3951",
      "stroke-width": "2",
      fill: "#fff",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 13h40v42H12V13z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.5 13.5v41M30 21h22m-22 8h22m-22 8h22m-22 9h22M31.5 13.5v41M21 21h20m-20 8h20m-20 8h20m-20 9h20M21.5 13.5v41M12 21h20m-20 8h20m-20 8h20m-20 9h20",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M32.188 14.063v32L24 46l13 11 14-11h-9.313l-.124-31.938h-9.376z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }